import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IScreen_Group_Employee_Grid_Card_with_Search_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IScreen_Group_Employee_Grid_Card_with_Search_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class Screen_Group_Employee_Grid_Card_with_Search_ScreenBase extends React.PureComponent<
  IScreen_Group_Employee_Grid_Card_with_Search_ScreenProps,
  any
> {
  screen_group_employee_grid_card_with_search_61004_value_kuikaSelectBoxRef: React.RefObject<any>;
  screen_group_employee_grid_card_with_search_825866_value_kuikaDateRef: React.RefObject<any>;
  screen_group_employee_grid_card_with_search_440196_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "a43d6f65-5173-4e2a-bd00-6bc445d3ef4d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 750222, PropertyName: "label", Value: "Profile" },
        { Id: 532153, PropertyName: "label", Value: "Logout" },
        { Id: 260468, PropertyName: "placeholder", Value: "Search" },
        { Id: 61004, PropertyName: "placeholder", Value: "Select..." },
        { Id: 825866, PropertyName: "placeholder", Value: "Select Date..." },
        {
          Id: 440196,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 543588, PropertyName: "value", Value: "James Alba" },
        { Id: 182006, PropertyName: "value", Value: "Software Engineer" },
        { Id: 763910, PropertyName: "value", Value: "Software Engineer" },
        { Id: 121903, PropertyName: "value", Value: "james.alba@kuika.com" },
        { Id: 326653, PropertyName: "value", Value: "+1112 444 55 66" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.screen_group_employee_grid_card_with_search_260468_value_kuikaTextInputRef =
      React.createRef();
    this.screen_group_employee_grid_card_with_search_61004_value_kuikaSelectBoxRef =
      React.createRef();
    this.screen_group_employee_grid_card_with_search_825866_value_kuikaDateRef =
      React.createRef();
    this.screen_group_employee_grid_card_with_search_440196_value_kuikaGalleryViewRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "screen_group_employee_grid_card_with_search",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "screen_group_employee_grid_card_with_search",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "screen_group_employee_grid_card_with_search",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
